import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { BuildYourBundle, Layout, SEO } from '@components';
import { getGlobalProps } from '@utils/get-global-props';
import { useCollectionsQuery } from '@utils/react-query';
import { useActiveFrame, useTranslation } from '@utils/hooks';
import { BASE_FRAME_NAMES, LOCALE_DICT } from '@constants';
import { getMarketingRedirect } from '@services/contentful';

const getTranslatedTexts = translator => {
	return {
		newBuildYourBundle: translator('new-build-your-bundle'),
	};
};

const BuildYourOwnBundle = () => {
	const [activeFrame] = useActiveFrame();
	const [frameShape, setFrameShape] = useState<(typeof BASE_FRAME_NAMES)[number]>(activeFrame);
	const { translator } = useTranslation();
	const translations = getTranslatedTexts(translator);

	const { locale } = useRouter();
	const { countryCode: country, languageCode: language } = LOCALE_DICT[locale];

	const { data: collectionsData } = useCollectionsQuery('byob-collection', {
		queryKey: `build-bundle-collections`,
		queryRefreshVars: [locale, frameShape],
		type: 'buildflow',
		withProducts: true,
		skipVariants: true,
		includeSpecificFrameVariant: true,
		selectedOptions: [
			{
				name: 'Frame',
				value: frameShape,
			},
		],
		country,
		language,
	});

	return (
		<>
			<SEO title={translations.newBuildYourBundle} />
			<BuildYourBundle collection={collectionsData?.[0]} setFrameShape={setFrameShape} frameShape={frameShape} />
		</>
	);
};

//TODO: change to getStaticProps
export async function getServerSideProps({ locale }) {
	const { pageType: marketingPageType, redirectTo } = await getMarketingRedirect('build-your-own-bundle');

	if (marketingPageType === 'Redirect') {
		return {
			redirect: { destination: redirectTo, permanent: false },
		};
	}

	const globalProps = await getGlobalProps({ locale });
	return {
		props: {
			...globalProps,
		},
	};
}

BuildYourOwnBundle.getLayout = function getLayout(page, pageProps) {
	return <Layout pageProps={pageProps}>{page}</Layout>;
};

export default BuildYourOwnBundle;
